import React from "react";

const CustomCheckbox = ({
  checked,
  onChange,
  label = "",
  disabled = false,
  className = "",
}) => {
  return (
    <label
      className={`relative inline-flex items-center gap-2 select-none
        ${disabled ? "cursor-not-allowed opacity-60" : "cursor-pointer"}
        ${className}`}
    >
      <input
        type="checkbox"
        className="peer hidden"
        checked={checked}
        onChange={!disabled ? onChange : undefined}
        disabled={disabled}
      />

      {/* Checkbox box */}
      <span
        className={`w-4 h-4 border rounded transition-all duration-300
          ${
            disabled
              ? checked
                ? "border-gray-400 bg-gray-400"
                : "border-gray-400 bg-gray-200"
              : "border-[#4a4a4f] bg-transparent peer-checked:bg-[#85325F] peer-checked:border-[#85325F]"
          }`}
      />

      {/* Check icon */}
      <svg
        className={`absolute left-[2px] top-[3px] w-3 h-3
          transition-opacity duration-300 pointer-events-none
          ${checked ? "opacity-100" : "opacity-0"}
          ${disabled ? "text-gray-600" : "text-white"}`}
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <polyline points="20 6 9 17 4 12" />
      </svg>

      {/* Label text */}
      {label && (
        <span
          className={`text-sm ${
            disabled ? "text-gray-400" : "text-gray-700"
          }`}
        >
          {label}
        </span>
      )}
    </label>
  );
};

export default CustomCheckbox;
